import messages from '../locales/en_US.json';

const EnLang = {
  messages: {
    ...messages
  },
  locale: 'en-US',
};
export default EnLang;
